import { gql } from '@apollo/client/core';

const ConfigurationFragment = gql`
  fragment ConfigurationFragment on PublicPortfolioConfiguration {
    fieldCalendarLinkIsPublic
    fieldLinkedinSlugIsPublic
    fieldPhoneIsPublic
    fieldPublicEmailIsPublic
    isPublic
    sectionAwardsIsPublic
    sectionClientsIsPublic
    sectionConnectionsIsPublic
    sectionContactsIsPublic
    sectionHeadlineIsPublic
    sectionSalesExperienceIsPublic
    sectionTestimonialsIsPublic
    sectionWorkHistoriesIsPublic
    sectionEducationHistoriesIsPublic
  }
`;

export default ConfigurationFragment;
